import * as React from 'react';
import getHighlightedTextForSuggestion from '../../utils/getHighlightedTextForSuggestion';
import highlightDisplayText from '../../utils/highlightDisplayText';
import SearchSuggestion from './SearchSuggestion';
import { ControlIcons } from 'owa-control-icons';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { KeywordSuggestion } from 'owa-search-service';
import { observer } from 'mobx-react-lite';
import { SearchScenarioId } from '../../store/schema/SearchScenarioId';
import { SMALL_SUGGESTION_HEIGHT } from '../../searchConstants';

const searchSuggestionStyles = require('./SearchSuggestion.scss');
const styles = require('./TextSearchSuggestion.scss');

export interface TextSearchSuggestionProps {
    index: number;
    scenarioId: SearchScenarioId;
    suggestion: KeywordSuggestion;
    suggestionSetTraceId: string;
}

const TextSearchSuggestion = observer(function TextSearchSuggestion(
    props: TextSearchSuggestionProps
) {
    const { index, scenarioId, suggestion, suggestionSetTraceId } = props;

    const highlightTextRegions = highlightDisplayText(suggestion.DisplayText);

    const style: React.CSSProperties = {
        lineHeight: `${SMALL_SUGGESTION_HEIGHT}px`,
    };

    return (
        <SearchSuggestion
            ariaLabel={suggestion.DisplayText}
            content={
                <div className={styles.container} style={style}>
                    <Icon
                        className={searchSuggestionStyles.icon}
                        iconName={
                            suggestion.Attributes && suggestion.Attributes.IsHistory
                                ? ControlIcons.History
                                : ControlIcons.Search
                        }
                    />
                    {getHighlightedTextForSuggestion(highlightTextRegions)}
                </div>
            }
            suggestion={suggestion}
            scenarioId={scenarioId}
            suggestionSetTraceId={suggestionSetTraceId}
            index={index}
        />
    );
});
export default TextSearchSuggestion;
